type MarkProps = {
  className?: string;
  size?: number;
};

/**
 * NS double-hairpin mark used as the foreground glyph of the Dev Portal logo.
 * Renders pure SVG; takes its color from `currentColor` so callers control
 * the fill via CSS (typically `var(--ns-color-fg-logo)`).
 *
 * Always decorative: callers compose this inside `LogoIcon` / `LogoFull`,
 * which carry the accessible name.
 */
export function Mark({ className, size = 24 }: MarkProps) {
  return (
    <svg
      aria-hidden="true"
      className={className}
      fill="none"
      height={size}
      viewBox="0 0 40 40"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.4709 7.44154C23.5709 7.19154 23.4209 7.06154 23.2609 7.03154C22.3209 6.86154 21.3709 7.39154 21.0309 8.31154C21.0309 8.31154 15.0109 24.8215 14.6709 25.7915C14.6209 25.9115 14.5409 25.9815 14.4309 26.0115C14.2609 26.0515 14.0509 26.0115 13.8709 25.8715C13.2809 25.4315 9.21091 22.1015 7.16091 20.4115C7.11091 20.3615 7.00091 20.1515 7.01091 19.8815C7.01091 19.6815 7.08091 19.5615 7.09091 19.5515L14.7409 14.0615C14.9609 13.9115 14.9109 13.7215 14.7909 13.6015C14.1109 12.9415 13.0309 12.8415 12.2309 13.4115L5.89091 17.9415C5.35091 18.3615 5.02091 19.0515 5.00091 19.8215C4.98091 20.6615 5.29091 21.4415 5.86091 21.9315C6.11091 22.1315 11.8909 26.9015 12.6709 27.4715C13.1609 27.8315 13.7209 28.0115 14.2809 28.0115C14.5009 28.0115 14.7209 27.9815 14.9409 27.9215C15.6409 27.7315 16.2109 27.2315 16.5209 26.5015C16.8909 25.4715 23.4709 7.42154 23.4709 7.42154V7.44154Z"
        fill="currentColor"
      />
      <path
        d="M34.1409 18.1215C33.8909 17.9215 28.1109 13.1515 27.3309 12.5815C26.6509 12.0815 25.8309 11.9115 25.0609 12.1215C24.3609 12.3115 23.7909 12.8115 23.4809 13.5415C23.1109 14.5715 16.5309 32.6215 16.5309 32.6215C16.4309 32.8715 16.5809 33.0015 16.7509 33.0315C17.6909 33.2015 18.6409 32.6715 18.9809 31.7515C18.9809 31.7515 25.0009 15.2415 25.3409 14.2715C25.3909 14.1515 25.4709 14.0815 25.5809 14.0515C25.7509 14.0015 25.9609 14.0515 26.1409 14.1915C26.7309 14.6315 30.8009 17.9615 32.8509 19.6515C32.9009 19.7015 33.0109 19.9115 33.0009 20.1815C33.0009 20.3815 32.9309 20.5015 32.9209 20.5115L25.2709 26.0015C25.0509 26.1515 25.1009 26.3415 25.2209 26.4615C25.9009 27.1215 26.9809 27.2215 27.7809 26.6515L34.1209 22.1115C34.6609 21.6915 34.9909 21.0115 35.0109 20.2315C35.0309 19.3915 34.7209 18.6115 34.1509 18.1215H34.1409Z"
        fill="currentColor"
      />
    </svg>
  );
}
